export const COMPANY = {
  name: "Maas Kozijn",
  shortName: "Maas Kozijn",
  initial: "M",
  tagline: "Complete nieuwe kunststof en aluminium kozijnen, schuifpuien en deuren — geleverd en gemonteerd in Zuid-Holland",
  locality: "Maassluis",
  openingHours: [["Maandag – vrijdag", "08:30 – 17:00"], ["Zaterdag en zondag", "Gesloten"]],
  phone: "+31 6 13838902",
  phoneDigits: "31613838902",
  phoneDisplay: "06 - 1383 8902",
  whatsappDigits: "31613838902",
  email: "info@maaskozijn.nl",
  region: "Zuid-Holland",
  whatsappText:
    "Goedendag Maas Kozijn, ik ontvang graag informatie over nieuwe kozijnen inclusief montage.",
};

// Productie URL — wordt gebruikt voor canonical, og:url en JSON-LD.
export const SITE_URL = "https://maaskozijn.nl";

export const WHATSAPP_LINK = `https://api.whatsapp.com/send/?phone=${COMPANY.whatsappDigits}&text=${encodeURIComponent(
  COMPANY.whatsappText
)}`;

export const PHONE_LINK = `tel:${COMPANY.phone.replace(/\s/g, "")}`;

// Nieuwe hoofdcategorieën — aluminium prominent, kunststof blijft kernproduct.
export const SERVICES = [
  // Aluminium (premium groeisegment)
  { slug: "aluminium-kozijnen", title: "Aluminium kozijnen", short: "Slanke profielen en grote glasvlakken.", href: "/aluminium-kozijnen", world: "aluminium" },
  { slug: "aluminium-deuren", title: "Aluminium deuren", short: "Robuust, modern en veilig.", href: "/aluminium-deuren", world: "aluminium" },
  { slug: "aluminium-schuifpui", title: "Aluminium schuifpui", short: "Maximaal licht, minimale profielen.", href: "/aluminium-schuifpui", world: "aluminium" },
  { slug: "aluminium-hefschuifpui", title: "Aluminium hefschuifpui", short: "Grote glasoppervlakken, soepele bediening.", href: "/aluminium-hefschuifpui", world: "aluminium" },
  // Kunststof (sterke volumebasis)
  { slug: "kunststof-kozijnen", title: "Kunststof kozijnen", short: "Comfortabel, energiezuinig, onderhoudsarm.", href: "/kunststof-kozijnen", world: "kunststof" },
  { slug: "kunststof-deuren", title: "Kunststof deuren", short: "Voor-, achter- en tuindeuren op maat.", href: "/kunststof-deuren", world: "kunststof" },
  { slug: "kunststof-schuifpui", title: "Kunststof schuifpui", short: "Prijsbewust alternatief voor grote puien.", href: "/kunststof-schuifpui", world: "kunststof" },
  // Puien overkoepelend
  { slug: "grote-puien", title: "Grote puien", short: "Woonkamer en tuin op maat verbonden.", href: "/grote-puien", world: "puien" },
  // Glas
  { slug: "hr-glas", title: "HR++ & triple glas", short: "Energiezuinig en geluidsisolerend.", href: "/hr++-glas-isolatieglas", world: "glas" },
];

// Hoofdnavigatie V3 — één bron voor header, mobiel menu en footer
export const NAV_LINKS = [
  {
    label: "Kozijnen", href: "/kunststof-kozijnen",
    children: [
      { label: "Kunststof kozijnen", href: "/kunststof-kozijnen", desc: "Onderhoudsarm en goed isolerend" },
      { label: "Aluminium kozijnen", href: "/aluminium-kozijnen", desc: "Slanke profielen, strakke uitstraling" },
      { label: "Kunststof of aluminium?", href: "/aluminium-of-kunststof-kozijnen", desc: "De verschillen nuchter uitgelegd" },
    ],
  },
  {
    label: "Schuifpuien", href: "/schuifpuien",
    children: [
      { label: "Alle schuifpuien", href: "/schuifpuien", desc: "Vergelijk de drie soorten" },
      { label: "Kunststof schuifpui", href: "/kunststof-schuifpui", desc: "Veel licht, prijsbewust" },
      { label: "Aluminium schuifpui", href: "/aluminium-schuifpui", desc: "Smalle aanzichten, grote vlakken" },
      { label: "Aluminium hefschuifpui", href: "/aluminium-hefschuifpui", desc: "Licht bedienbaar bij grote breedtes" },
      { label: "Grote puien", href: "/grote-puien", desc: "Waar u op let bij een brede opening" },
    ],
  },
  {
    label: "Deuren", href: "/deuren",
    children: [
      { label: "Alle deuren", href: "/deuren", desc: "Kunststof en aluminium vergeleken" },
      { label: "Kunststof deuren", href: "/kunststof-deuren", desc: "Voordeur, achterdeur en tuindeuren" },
      { label: "Aluminium deuren", href: "/aluminium-deuren", desc: "Strakke voordeuren en tuindeuren" },
    ],
  },
  { label: "Projecten", href: "/projecten" },
  {
    label: "Kosten & advies", href: "/kosten-kunststof-kozijnen-zuid-holland",
    children: [
      { label: "Kosten nieuwe kozijnen", href: "/kosten-kunststof-kozijnen-zuid-holland", desc: "Waar de prijs uit bestaat" },
      { label: "Werkwijze", href: "/werkwijze", desc: "Van aanvraag tot oplevering" },
      { label: "Montage & afwerking", href: "/montage", desc: "Hoe een kozijn goed geplaatst wordt" },
      { label: "HR++ of HR+++ glas", href: "/hr++-glas-isolatieglas", desc: "Glaskeuze bij nieuwe kozijnen" },
      { label: "Subsidie (ISDE)", href: "/isde-subsidie-kozijnen", desc: "Voorwaarden controleren" },
      { label: "Kennisbank", href: "/blog", desc: "Artikelen over materiaal en montage" },
      { label: "Veelgestelde vragen", href: "/veelgestelde-vragen", desc: "Korte, duidelijke antwoorden" },
    ],
  },
  { label: "Werkgebied", href: "/werkgebied" },
  { label: "Over ons", href: "/over-ons" },
  { label: "Contact", href: "/contact" },
];

// Niet (bevestigd) aangeboden — geen menu, noindex, niet in sitemap
export const SECONDARY_SERVICES = [];

export const waLink = (text) =>
  `https://api.whatsapp.com/send/?phone=${COMPANY.whatsappDigits}&text=${encodeURIComponent(text || COMPANY.whatsappText)}`;

// USP's — minder prijsvechter, meer vakmanschap
export const USPS = [
  { title: "Complete aanpak", desc: "Advies, inmeten, levering, montage en afwerking vanuit één aanspreekpunt." },
  { title: "Ervaren monteurs", desc: "Montage door ervaren vakmensen en vaste uitvoeringspartners." },
  { title: "Kwalitatieve kozijnsystemen", desc: "Moderne kunststof en aluminium systemen, waaronder Gealan-profielen, met goede isolatie- en afwerkingsmogelijkheden." },
  { title: "Persoonlijk contact", desc: "Direct contact met een regionale partij uit Maassluis." },
  { title: "Afwerking mogelijk", desc: "De aansluitende binnen- en buitenafwerking kan worden verzorgd wanneer dit onderdeel is van de opdracht." },
  { title: "Heldere afspraken", desc: "Een duidelijke offerte met omschreven werkzaamheden en een afgestemde planning." },
];

export const PROCESS_STEPS = [
  { n: 1, title: "Wensen en foto's doorgeven", desc: "Via de aanvraag, WhatsApp of telefoon. Een foto en globale maat zijn voor de eerste beoordeling voldoende." },
  { n: 2, title: "Eerste prijsindicatie", desc: "Op basis van uw antwoorden en foto's ontvangt u een persoonlijke richtprijs." },
  { n: 3, title: "Inmeten en definitieve offerte", desc: "Gratis inmeten bij u thuis; daarna een offerte met omschreven werkzaamheden." },
  { n: 4, title: "Productie en voorbereiding", desc: "De kozijnen worden op maat gemaakt; we stemmen de montagedag met u af." },
  { n: 5, title: "Montage en afwerking", desc: "Demontage, plaatsing, afdichting en — indien afgesproken — binnen- en buitenafwerking." },
  { n: 6, title: "Controle en oplevering", desc: "Samen lopen we het werk na en leggen we de bediening uit." },
];


// Bestaande projectenseeds — behouden (zie afspraak: 'doen alsof echt').
// Nieuwe commerciële teksten in projecten.jsx + ProjectDetail halen dit op.
export const PROJECTS = [
  {
    plaats: "Maassluis",
    titel: "Kunststof kozijnen Sluispolder",
    voor: "Tochtige houten kozijnen uit de jaren '70 met enkel glas en achterstallig schilderwerk.",
    werk: "12 kunststof kozijnen geplaatst met HR++ glas, antraciet aan de buitenzijde, wit aan de binnenzijde.",
    resultaat: "Direct minder geluid van het verkeer, lagere stookkosten en een frisse uitstraling.",
    img: "https://images.pexels.com/photos/12792317/pexels-photo-12792317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    plaats: "Vlaardingen",
    titel: "Hefschuifpui woonkamer",
    voor: "Oude pui, koud in de winter en kierend in de zomer — weinig lichtinval.",
    werk: "Hefschuifpui in mat zwart met HR++ veiligheidsglas, thermisch onderbroken profiel en soepele bediening.",
    resultaat: "Veel meer lichtinval, comfortabele woonkamer en een sterkere verbinding met het terras.",
    img: "https://images.pexels.com/photos/8134753/pexels-photo-8134753.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    plaats: "Schiedam",
    titel: "HR++ en kunststof kozijnen vooroorlogse woning",
    voor: "Bestaande kozijnen in slechte staat, condens en tocht in de hele woning.",
    werk: "Kunststof kozijnen met houtnerf-uitstraling en HR++ glas, afgestemd op de karakteristieke straatuitstraling.",
    resultaat: "Behoud van karakter, modern comfort en flink minder energieverbruik.",
    img: "https://images.unsplash.com/photo-1689097765651-c59617fc0cb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yJTIwd2luZG93c3xlbnwwfHx8fDE3NzcxNzk5MzF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    plaats: "Rotterdam",
    titel: "Nieuwe entree stadswoning",
    voor: "Verouderde houten voordeur met inbraakgevoelig slot.",
    werk: "Kunststof voordeur met meerpuntssluiting, geïsoleerde vulling en bijpassend zijlicht in HR++ glas.",
    resultaat: "Veiliger, stiller en een vriendelijkere entree van de woning.",
    img: "https://images.pexels.com/photos/30683491/pexels-photo-30683491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

// Nieuwe CTA-palet — contextueel, minder prijsvechter
export const CTA_VARIANTS = {
  advies: "Vraag persoonlijk advies",
  aluminium: "Bespreek uw aluminium project",
  pui: "Bespreek uw nieuwe pui",
  kunststof: "Ontvang advies voor uw woning",
  foto: "Stuur foto's via WhatsApp",
  projecten: "Bekijk vergelijkbare projecten",
  opname: "Plan een opname",
  // backwards compat
  whatsapp: "Stuur foto's via WhatsApp",
  offerte: "Vraag persoonlijk advies",
  bel: "Direct bellen",
};
